export default "__VITE_ASSET__CkC7Mltz__"